import React from 'react';

export default function TourTrigger({ onClick, pulsing = false, label = 'Quick Tour', tall = false }) {
  return (
    <button
      type="button"
      className={`tour-trigger${pulsing ? ' is-pulsing' : ''}${tall ? ' tour-trigger--tall' : ''}`}
      onClick={onClick}
      title="Replay the quick onboarding tour"
    >
      <span className="tour-trigger-icon" aria-hidden>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
      </span>
      {label}
    </button>
  );
}
